// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"FileUpload-fileThumbnail-thumbnail-b344f819","typeIcon":"FileUpload-fileThumbnail-typeIcon-c39094b3"};